export default __webpack_public_path__ + "static/media/simple-icon.0890cfd2.svg";